import { ChangeEvent, useState, useEffect } from 'react'
import { CategoriesType } from '../../redux/actions/types'
import { useAppSelector, useAppDispatch } from '../../redux/types/types'
import close from '../../assets/icons/close.svg'
import CustomCheckbox from '../UI/CustomCheckbox/CustomCheckbox'
import styles from './AddCategoriesModal.module.css'
import CustomButton from '../UI/CustomButton/CustomButton'
import {
  changeMenuMainInformation,
  getAllMenu,
  getCurrentMenu,
} from '../../redux/actions/menuAction'
import { menuPerPage } from '../../constants/constants'
import { useLocation, useNavigate } from 'react-router-dom'
interface AddCategoriesModalProps {
  isOpen: boolean
  onClose: () => void
  selectedMenuId: string
  submited: () => void
}

const AddCategoriesModal: React.FC<AddCategoriesModalProps> = ({
  isOpen,
  onClose,
  selectedMenuId,
  submited,
}) => {
  const [checkedState, setCheckedState] = useState<string[]>([])
  const [curMenu, setCurMenu] = useState<any>(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [searchQuery, setSearchQuery] = useState('')

  const { category } = useAppSelector((state) => state.categories)
  const { token } = useAppSelector((state) => state.auth)
  const { currentMenu } = useAppSelector((state) => state.menu)

  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (selectedMenuId) {
      dispatch(getCurrentMenu({ token, menuId: selectedMenuId }))
    }
  }, [selectedMenuId, dispatch, token])

  useEffect(() => {
    if (currentMenu && currentMenu.menuCategories) {
      setCurMenu(currentMenu.menuCategories)

      const preCheckedCategories = currentMenu.menuCategories
        .filter((cat: any) => cat?.category)
        .map((cat: any) => String(cat.category.id))
      setCheckedState(preCheckedCategories)
    }
  }, [currentMenu])

  const removeCategoryParam = () => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete('category')
    navigate(`${location.pathname}?${searchParams.toString()}`)
  }

  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.id
    const checked = e.target.checked

    if (checked) {
      setCheckedState([...checkedState, value])
    } else {
      setCheckedState(checkedState.filter((c) => c !== value))
    }
  }

  const handleSubmit = async () => {
    try {
      await dispatch(
        changeMenuMainInformation({
          token,
          menuId: selectedMenuId,
          name: curMenu.name,
          description: String(curMenu.description),
          categoryIds: checkedState,
        }),
      )
      await dispatch(getCurrentMenu({ menuId: String(selectedMenuId), token }))
      dispatch(
        getAllMenu({
          token,
          page: currentPage,
          itemsPerPage: menuPerPage,
          name: location.state,
        }),
      )

      if (checkedState.length === 0) {
        removeCategoryParam()
      }

      submited()
      onClose()
    } catch (error) {
      console.error('Error updating menu:', error)
    }
  }

  const dummyData = (array: CategoriesType[]) => {
    return array.map((category) => ({
      id: category.id,
      title: category.name,
      subTitle: category.description,
      products: category.products,
    }))
  }

  const eventList = dummyData(category.category)

  const filteredCategories = eventList.filter((category) =>
    category.title.toLowerCase().includes(searchQuery.toLowerCase()),
  )

  if (!isOpen) return null

  return (
    <div className={styles.AddCategoryModalOverlay}>
      <div className={styles.AddCategoryModal}>
        <div className={styles.titleBlock}>
          <h1 className={styles.title}>Добавить категории</h1>
          <img
            onClick={() => {
              onClose()
            }}
            className={styles.close}
            src={close}
            alt='close'
          />
        </div>

        <div className={styles.checkboxBlock}>
          {filteredCategories.map((category) => (
            <div key={category.id}>
              <CustomCheckbox
                id={String(category.id)}
                checked={checkedState.includes(String(category.id))}
                value={category.title}
                onChange={handleCheckboxChange}
                className={styles.checkboxStyle}
                spanClassName={styles.spanStyle}
              >
                {category.title}
              </CustomCheckbox>
            </div>
          ))}
        </div>

        <div className={styles.addCategoriesButtonsBlock}>
          <CustomButton
            className={styles.clearBtn}
            title='Очистить все'
            type='button'
            onClick={() => setCheckedState([])}
          />
          <CustomButton
            className={styles.addSiteBtn}
            title='Добавить'
            type='button'
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  )
}

export default AddCategoriesModal
